const initialState = {
  loading: false,
  error: null,
  message: null,
  landing: null,
  homepagePlansLoading: false,
  homepageplans: null,
  homepagePlansError: null,
  latestArticles: null,
  categoryArticles: {},
  categoryArticlesLoader: [],
  categoryArticlesError: [],
  upcomingWebinarsLoading: false,
  upcomingWebinars: null,
  upcomingWebinarsError: null,
  topCategoriesLoading: false,
  topCategories: null,
  topCategoriesError: null,
  homePageBanner: null,
  faqs: [],
  homePageSeoData: null,
  homePageSeoDataError: null,
};

const HomePageReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_HOMEPAGE_PLANS_REQUEST":
      return {
        ...state,
        homepagePlansLoading: true,
      };
    case "GET_HOMEPAGE_PLANS_SUCCESS":
      return {
        ...state,
        homepagePlansLoading: false,
        homepageplans: action.payload,
      };
    case "GET_HOMEPAGE_PLANS_FAILURE":
      return {
        ...state,
        homepagePlansLoading: false,
        homepagePlansError: action.payload,
      };
    case "GET_HOMEPAGE_WEBINARS_REQUEST":
      return {
        ...state,
        upcomingWebinarsLoading: true,
      };
    case "GET_HOMEPAGE_WEBINARS_SUCCESS":
      return {
        ...state,
        upcomingWebinarsLoading: false,
        upcomingWebinars: action.payload,
      };
    case "GET_HOMEPAGE_WEBINARS_FAILURE":
      return {
        ...state,
        upcomingWebinarsLoading: false,
        upcomingWebinarsError: action.payload,
      };
    case "GET_HOMEPAGE_CATEGORIES_REQUEST":
      return {
        ...state,
        topCategoriesLoading: true,
      };
    case "GET_HOMEPAGE_CATEGORIES_SUCCESS":
      return {
        ...state,
        topCategoriesLoading: false,
        topCategories: action.payload,
      };
    case "GET_HOMEPAGE_CATEGORIES_FAILURE":
      return {
        ...state,
        topCategoriesLoading: false,
        topCategoriesError: action.payload,
      };
    case "GET_HOMEPAGE_ARTICLES_SUCCESS":
      return {
        ...state,
        latestArticles: action.payload,
      };
    case "GET_HOMEPAGE_ARTICLES_FAILURE":
      return {
        ...state,
        error: action.payload,
      };
    case "GET_HOMEPAGE_CATEGORY_ARTICLES_REQUEST":
      let categoryLoader = [...state.categoryArticlesLoader];
      if (action.key) {
        categoryLoader[action.key] = true;
      }
      return {
        ...state,
        categoryArticlesLoader: categoryLoader,
      };

    case "GET_HOMEPAGE_CATEGORY_ARTICLES_SUCCESS":
      let categoryData = { ...state.categoryArticles };
      categoryData[action.key] = {};
      categoryData[action.key] = action.payload;
      return {
        ...state,
        categoryArticles: categoryData,
      };
    case "GET_HOMEPAGE_CATEGORY_ARTICLES_FAILURE":
      let categoryError = [...state.categoryArticlesError];
      let categoryLoaderError = [...state.categoryArticlesLoader];
      categoryError[action.key] = action.payload;
      return {
        ...state,
        categoryArticlesError: categoryError,
        categoryArticlesLoader: categoryLoaderError,
      };
    case "GET_HOMEPAGE_LANDING_SUCCESS":
      return {
        ...state,
        landing: action.payload,
      };
    case "GET_HOMEPAGE_LANDING_FAILURE":
      return {
        ...state,
        error: action.payload,
      };
    case "GET_HOMEPAGE_BANNER_SUCCESS":
      return {
        ...state,
        homePageBanner: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case "GET_HOMEPAGE_BANNER_FAILURE":
      return {
        ...state,
        homePageBanner: {
          data: null,
          loading: false,
          error: action.payload,
        },
      };
    case "GET_FAQ_REQUEST":
      return {
        ...state,
        faqs: { data: "", loading: true, error: null },
      };
    case "GET_FAQ_SUCCESS":
      return {
        ...state,
        faqs: { data: action.payload, loading: false, error: null },
      };
    case "GET_FAQ_FAILURE":
      return {
        ...state,
        faqs: { data: action.payload, loading: false, error: action.payload },
      };

    case "GET_HOMEPAGE_SUCCESS":
      return {
        ...state,
        homePageSeoData: action.payload,
      };
    case "GET_HOMEPAGE_FAILURE":
      return {
        ...state,
        homePageSeoDataError: action.payload,
      };

    default:
      return state;
  }
};

export default HomePageReducer;
